import { WPNewsletter } from 'Shared/newsletter';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

onDomReady(() => {
   document.querySelectorAll('.newsletter-sub').forEach(newsLetterEL => {
      new WPNewsletter(newsLetterEL, App.wpSlug);
   });

   document.querySelectorAll('.js-product-ad').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Featured Products - WP Pages',
            eventAction: `Featured on WP Pages - ${App.postTitle} - ${App.postid} - ${el.get(
               'data-ga-product'
            )}`,
         });
      });
   });

   // Track blog article share/copy link button clicks
   document.querySelectorAll('.entry-share .btn, .js-copy-link').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Blog Article',
            eventAction: 'Blog Article - Copy Link',
            eventName: window.location.href,
         });
      });
   });
});
